// Custom DatePicker that uses Day.js instead of Moment.js
import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  min-height: 80vh;\n  padding-bottom: 0;\n  overflow-x: hidden;\n  background-color: ",
        ";\n  &.header-fixed {\n    padding-top: 85px;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { View } from "@/components";
import Home from "@/components/Home";
import { PreviewDialogProvider } from "@/components/Search/PreviewDialogProvider";
import { styled } from "@mui/material";
const HomePageWrapper = styled(View)(_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.palette.grey[50];
});
const HomePage = (param)=>{
    let { auth  } = param;
    return /*#__PURE__*/ _jsx("div", {
        children: /*#__PURE__*/ _jsx(PreviewDialogProvider, {
            children: /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx(Home, {})
            })
        })
    });
};
export default HomePage;
